import React, { useEffect, useState } from "react";
import "./auth.css";
import LoginInput from "./common/LoginInput";
import { iResetForm } from "./common/types";
import { initialResetForm } from "./common/initialValues";
import { useHistory, useParams } from "react-router-dom";
import * as passwordService from "services/emailService";
import GenericModal from "components/common/GenericModal";
import { ICONS } from "components/common/constants/swal.constants";

interface ResetPasswordProps {}
export interface GenericModalProps {
  show: boolean;
  title?: string;
  subtext?: string;
  htmlSubtext?: string;
  btnText?: string;
  onBtnClick?: () => void;
  icon?: string;
  proceedBtnText?: string;
  onProceedBtnClick?: () => void;
}
const ResetPassword: React.FC<ResetPasswordProps> = () => {
  const [formData, setFormData] = useState<iResetForm>(initialResetForm);
  const [genericModalData, setGenericModalData] = useState<GenericModalProps>({
    show: false,
  });
  const history = useHistory();
  const { token } = useParams<{ token: string }>();

  const handleChange = (prop: string) => (value: string) => {
    setFormData((prev: iResetForm) => ({
      ...prev,
      [prop]: value,
    }));
  };

  const handleSubmit = () => {
    passwordService
      .resetPass(formData)
      .then((res) => {
        if (res.error) throw new Error(res.error);

        setGenericModalData({
          show: true,
          title: "Success",
          subtext: "",
          icon: ICONS.checkMark,
        });
        setTimeout(() => {
          history.push("/login");
        }, 2000);
      })
      .catch((error) => {
        setGenericModalData({
          show: true,
          title: "An error occurred!",
          subtext: error.message,
          icon: ICONS.error,
        });
      });
  };
  const handleGenericModalToggle = (toggle: boolean) => {
    setGenericModalData((prev: GenericModalProps) => ({
      ...prev,
      show: toggle,
    }));
  };
  useEffect(() => {
    if (token) {
      setFormData((prevFormData) => ({
        ...prevFormData,
        token,
      }));
    }
  }, [token]);
  return (
    <div className="login-container">
      {genericModalData.show && (
        <GenericModal
          show={genericModalData.show}
          onHide={() => handleGenericModalToggle(false)}
          title={genericModalData?.title || ""}
          subtext={genericModalData?.subtext || ""}
          btnText="OK"
          onBtnClick={() => handleGenericModalToggle(false)}
          icon={genericModalData?.icon || undefined}
        />
      )}
      <div className="login-content-container">
        <p className="login-form-title">Reset your password</p>
        <div className="login-form-container">
          <LoginInput
            label="New Password"
            value={formData?.password}
            name={"password"}
            onChange={handleChange}
            type="password"
            placeholder="Enter new password"
          />
          <LoginInput
            label="Confirm New Password"
            value={formData?.passwordConfirm}
            name={"passwordConfirm"}
            onChange={handleChange}
            type="password"
            placeholder="Confirm new password"
          />
          <button className="login-form-btn" onClick={handleSubmit}>
            Update
          </button>
        </div>
      </div>
    </div>
  );
};

export default ResetPassword;
